import React from 'react';
import PropTypes from 'prop-types';
import {
	IconCircleCheck,
	IconCircle,
	IconStar,
	IconStarFilled,
	IconMicrophone,
	IconPlayerPlay,
	IconPencil,
	IconTrash,
} from '@tabler/icons-react';
import { useFlow } from 'hooks';

function FlowTableRow({ item }) {
	const { id, name, active, favorite, voiceControl } = item;
	const { handleTrigger } = useFlow();

	const onTrigger = () => handleTrigger(id);

	return (
		<tr className="hover:bg-[--color-bg-secondary] transition-colors">
			<td
				className="px-4 py-3 text-xs font-medium"
				style={{ color: 'var(--color-text-tertiary)' }}
			>
				{id}
			</td>
			<td
				className="px-4 py-3 text-sm"
				style={{ color: 'var(--color-text-primary)' }}
			>
				{name}
			</td>
			<td className="px-4 py-3">
				{active ? (
					<IconCircleCheck size={16} style={{ color: '#76BC21' }} />
				) : (
					<IconCircle size={16} style={{ color: 'var(--color-border-light)' }} />
				)}
			</td>
			<td className="px-4 py-3">
				{favorite ? (
					<IconStarFilled size={16} className="text-amber-400" />
				) : (
					<IconStar size={16} style={{ color: 'var(--color-border-light)' }} />
				)}
			</td>
			<td className="px-4 py-3">
				{voiceControl ? (
					<IconMicrophone size={16} className="text-amber-400" />
				) : null}
			</td>
			<td className="px-4 py-3">
				<div className="flex items-center gap-1">
					<button
						type="button"
						onClick={onTrigger}
						className="p-1.5 rounded border transition-colors"
						style={{
							color: '#76BC21',
							borderColor: '#76BC21',
						}}
						aria-label="Kör flow"
					>
						<IconPlayerPlay size={12} />
					</button>
					<button
						type="button"
						className="p-1.5 rounded border transition-colors text-blue-500 border-blue-300 hover:bg-blue-500 hover:text-white"
						aria-label="Redigera flow"
					>
						<IconPencil size={12} />
					</button>
					<button
						type="button"
						className="p-1.5 rounded border transition-colors text-red-400 border-red-300 hover:bg-red-500 hover:text-white"
						aria-label="Ta bort flow"
					>
						<IconTrash size={12} />
					</button>
				</div>
			</td>
		</tr>
	);
}

FlowTableRow.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		active: PropTypes.number,
		favorite: PropTypes.number,
		voiceControl: PropTypes.number,
	}).isRequired,
};

export default FlowTableRow;
